var _excluded = ["children", "escapePress"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledModal } from './StyledModal';
function Modal(_ref) {
  var children = _ref.children,
    escapePress = _ref.escapePress,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledModal, _extends({}, rest, {
    disableEscapeKeyDown: !escapePress
  }), children);
}
Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Contents to display inside dialog
   */
  children: PropTypes.node.isRequired,
  /**
   * If `false`, hitting escape will not fire the `onClose` callback.
   */
  escapePress: PropTypes.bool,
  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: PropTypes.bool,
  /**
   * If `true`, the dialog stretches to maxWidth.
   * Notice that the dialog width grow is limited by the default margin.
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Determine the max-width of the dialog. The dialog width grows
   * with the size of the screen. Set to `false` to disable `maxWidth`
   */
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the Dialog is open.
   */
  open: PropTypes.bool
} : {};
Modal.defaultProps = {
  escapePress: false,
  fullScreen: false,
  fullWidth: false,
  hideBackdrop: false,
  maxWidth: 'sm',
  onClose: function onClose() {},
  open: false
};
export default Modal;